import request from "../utils/fetch";

// 获取首页数据统计---订单
export function orderStatistics(data) {
  return request({
    url: "/order-common/enterprise/statistics/get/home",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 获取首页数据统计---设备
export function shebeiStatistics(data) {
  return request({
    url: "/equipment-common/foreign/api/company/deviceStatistics",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 获取首页数据统计---客户
export function userStatistics(data) {
  return request({
    url: "/user/sysmanager/countUser",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 近七日订单数据
export function aboutSevenOrder(data) {
  return request({
    url: "/order-common/enterprise/statistics/get/seven/day/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 近30日订单数据
export function aboutMonthOrder(data) {
  return request({
    url: "/order-common/enterprise/statistics/get/thirty/day/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 水卡
export function waterCard(data) {
  return request({
    url: "/user/card/company/count",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

export function monthStat(data) {
  return request({
    url: "/order-common/enterprise/statistics/get/by/month",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

export function yearStat(data) {
  return request({
    url: "/order-common/enterprise/statistics/get/by/year",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 根据时间查询折线
export function forTime(data) {
  return request({
    url: "/order-common/enterprise/statistics/get/list/between/day",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 主页数据--水卡总数详情
export function mainCardDetail(data) {
  return request({
    url: "/user-common/foreign/api/company/waterCardStatistics",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 服务端类型
export function serverHttp(data) {
  return request({
    url: "/equipment-common/foreign/api/device/type",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}
